import React, { useState } from "react";
import { useFormik } from 'formik';
import {
  Box,
  Typography,
  Button,
  Divider,
  Grid,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Cancel} from "@mui/icons-material";
import uploadIcon from "../../assets/GiftAsset/upload.svg"; 
// import VideoIcon from "../../assets/GiftAsset/video.svg"; 




const UploadStep = ({ handleNext, handleBack, formData, setFormData,errors }) => {
 // eslint-disable-next-line
  const [uploading, setUploading] = useState(false);
  // eslint-disable-next-line

  // eslint-disable-next-line
  const [imageFiles, setImageFiles] = useState([]);
  // const [url, setUrl] = useState(formData.videoUrl || "");  // Initialize video URL
  // const [uploadProgress, setUploadProgress] = useState(0);  
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  
  const initialValues = {
    images: [],
    
  };
  
  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      console.log(values);
    },
  });
  
 

    

   






  // const handleUrlChange = (e) => {
  //   setUrl(e.target.value);
  //   if (e.target.value) {
  //     setFormData((prev) => ({ ...prev, videoUrl: e.target.value, video: null }));
  //   }
  // };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    let updatedImages = [...formik.values.images];
  
    files.forEach((file) => {
      const reader = new FileReader();
      if (file.type.startsWith("image/") && updatedImages.length < 4) {
        reader.onloadend = () => {
          updatedImages.push(reader.result); // Base64 string
          formik.setFieldValue("images", updatedImages);
          setImageFiles(updatedImages);
          setFormData((prev) => ({ ...prev, images: updatedImages }));
        };
        reader.readAsDataURL(file);
      }
    });
  };
  

  
  
  
  
  
  

  const removeImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index),
    }));
  };

  const handleDrop = (event) => {
    event.preventDefault();
  
    const file = event.dataTransfer?.files?.[0];
  
    if (!file) return;
  
    const isImage = file.type.startsWith("image/");
  
    if (isImage) {
      handleImageUpload({ target: { files: [file] } });
    } else {
      console.warn("Only image files are allowed.");
    }
  };
  
  
  

  const handleNextClick = () => {
    // Pass the formData (which now contains Base64 strings) to the next step.
    handleNext(formData);
  };

  return (
    <Box
      sx={{
        maxWidth: 800,
        margin: "auto",
        padding: 5,
        borderRadius: 2,
        boxShadow: 3,
        bgcolor: "#fff",
      }}
    >
      <Typography
     
        color="#5604F6"
        textAlign="center"
        sx={{
          fontSize: isDesktop ? "48px" : "24px", 
          ...theme.typography.urbanist800
        }}
      >
        Upload Images 
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
             <Box sx={{ p: 1,  bgcolor: "#eee", borderRadius: 2, display: "inline-block" }}>
                              <Typography variant="caption" color="#5604F6" fontWeight={500}  sx={{ fontSize: isDesktop ? 18 : 20 }} >
                                Instructions
                              </Typography>  
                            </Box>
  <Typography variant="body2" sx={{ color: "gray",  textAlign: "justify" ,  fontSize: isDesktop ? 18  : 20 }} >
          Choose the most relevant category for your product to help buyers find it easily.
        </Typography>
      </Box>

      {/* Image Upload Section */}
      <Box sx={{ mt: 2 }}>
        <Typography fontSize="24px" sx={{ ...theme.typography.urbanist500, color: "#000000" }}>
          Image Upload
        </Typography>
        <Typography fontSize="18px" sx={{ ...theme.typography.Inter400, mb: 2 }}>
          Upload at least one image to proceed, you can upload up to 4 files max
        </Typography>

        <Box
          sx={{
            padding: 8,
            border: "2px dashed #ccc",
            textAlign: "center",
            borderRadius: "12px",
            mt: "4px",
          }}
        >
          <img src={uploadIcon} alt="upload icon" />
          <Typography sx={{ ...theme.typography.urbanist600, color: "gray" }}  onDrop={handleDrop}
          onDragOver={(event) => event.preventDefault()}>
            Drag your file(s) to start uploading
          </Typography>
          <input
            type="file"
            multiple
            accept="image/*"
            hidden
            id="image-upload"
            onChange={handleImageUpload}
          />
          <label htmlFor="image-upload">
            <Divider
              sx={{ my: 2, color: "gray", fontSize: "16px", fontWeight: 500 }}
            >
              OR
            </Divider>
            <Button
              variant="outlined"
              component="span"
              sx={{
                mt: 1,
                borderColor: "#5604F6",
                color: "#5604F6",
                textTransform: "none",
                borderRadius: "10px",
              }}
            >
              Browse Files
            </Button>
          </label>
        </Box>

        {/* Show upload count */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}
        >
          <Typography
            fontSize="16px"
            sx={{ color: "#6D6D6D", ...theme.typography.Inter400 }}
          >
            Only support .jpg, .png, and .webp files
          </Typography>
          <Typography
            fontSize="16px"
            sx={{ color: "#5604F6", ...theme.typography.Inter600 }}
          >
            {formData.images ? formData.images.length : 0}/4 Uploaded
          </Typography>
        </Box>

        {/* Display images */}
        <Grid container spacing={2} sx={{ mt: 2 }}>
        {formData.images?.length > 0 &&
  formData.images.map((imgSrc, index) => (

              <Grid item xs={6} key={index}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: 1,
                    borderRadius: 2,
                    boxShadow: 1,
                    bgcolor: "#f8f8f8",
                  }}
                >
                  <img
                    src={imgSrc}
                    alt={`preview-${index}`}
                    style={{
                      width: 40,
                      height: 40,
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                  <Box sx={{ ml: 2, flexGrow: 1 }}>
                    <Typography fontSize="14px" sx={{ fontWeight: 500 }}>
                      Image {index + 1}
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={() => removeImage(index)}
                    sx={{
                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                      color: "#5604F6",
                      borderRadius: "50%",
                      width: 24,
                      height: 24,
                    }}
                  >
                    <Cancel fontSize="small" />
                  </IconButton>
                </Box>
              </Grid>
            ))}
        </Grid>
      </Box>

      {/* Video Upload Section */}
      {/* <Box sx={{ mt: 8 }}>
  <Typography fontSize="24px" sx={{ ...theme.typography.urbanist500, color: "#000000" }}>
    Video Upload
  </Typography>
  <Typography fontSize="18px" sx={{ ...theme.typography.Inter400, mb: 2 }}   onDrop={handleDrop}
  onDragOver={(event) => event.preventDefault()}>
    Drag & drop or upload a product video (max: 60 seconds).
  </Typography>

  <Box
    sx={{
      padding: 8,
      border: "2px dashed #ccc",
      textAlign: "center",
      borderRadius: "12px",
      mt: "4px",
    }}
  >
    <img src={VideoIcon} alt="video upload icon" />
    <Typography sx={{ ...theme.typography.urbanist600, color: "gray" }}>
      Drag your file(s) to start uploading
    </Typography>
    <input
      type="file"
      accept="video/mp4"
      hidden
      id="video-upload"
      onChange={handleVideoUpload}
    />
    <label htmlFor="video-upload">
      <Divider sx={{ my: 2, color: "gray", fontSize: "16px", fontWeight: 500 }}>
        OR
      </Divider>
      <Button
        variant="outlined"
        component="span"
        sx={{
          mt: 1,
          borderColor: "#5604F6",
          color: "#5604F6",
          textTransform: "none",
          borderRadius: "10px",
        }}
      >
        Browse Files
      </Button>
    </label>
  </Box>

  {/* Display uploaded video if available */}
  {/* {formData.videos?.length > 0 && (
    <Box sx={{ mt: 2 }}>
      <Typography fontSize="18px" sx={{ fontWeight: 500 }}>
        Uploaded Video
      </Typography>
      <video
        src={formData.videos[0]}
        controls
        style={{ width: "100%", borderRadius: "10px", marginTop: "10px" }}
      />
      <IconButton
        onClick={() => setFormData((prev) => ({ ...prev, videos: [] }))}
        sx={{
          mt: 1,
          backgroundColor: "rgba(0, 0, 0, 0.1)",
          color: "#5604F6",
          borderRadius: "50%",
        }}
      >
        <Cancel fontSize="small" />
      </IconButton>
    </Box>
  )}
</Box> */} 

{/* 
      <Divider
        sx={{
          my: 2,
          color: "gray",
          fontSize: "16px",
          fontWeight: 500,
        }}
      >
        OR
      </Divider> */}

      {/* Video URL Input */}
      {/* <Box sx={{ mt: 2 }}>
        <TextField
          fullWidth
          label="Add Video URL"
          value={url}
          onChange={handleUrlChange}
          variant="outlined"
          InputProps={{
            sx: { borderRadius: "12px" },
            endAdornment: url && (
              <IconButton
                onClick={() => setUrl("")}
                sx={{ backgroundColor: "#f0f0f0", borderRadius: "50%" }}
              >
                <Close />
              </IconButton>
            ),
          }}
        />
      </Box> */}

      {/* Navigation Buttons */}
 <Box sx={{ display: "flex", justifyContent:"center", flexDirection: isDesktop ? "row" : "column", mt: 3, width: "100%", gap: 2 }}>
        <Button
          sx={{
            width: isDesktop ? "40%" : "100%",
            padding: "10px 20px", 
            borderRadius: "25px", 
            backgroundColor: "#EEE6FE  !important",
            color: "#5604F6!important",
            textTransform: "none",
            fontSize: isDesktop ? "16px" : "18px",
            "&:hover": { backgroundColor: "#B0B0B0" },
          }}
          onClick={handleBack}
        >
          {"< Back to step 2"}
        </Button>

        <Button
          
          sx={{
            width: isDesktop ? "40%" : "100%", 
            padding: "10px 20px", 
            borderRadius: "25px",
            backgroundColor: "#5604F6 !important",
            color: "#EEE6FE !important",
            textTransform: "none",
            fontSize: isDesktop ? "16px" : "18px",
            "&:hover": { backgroundColor: "#4b00c2" },
          }}
          onClick={handleNextClick}
        >
          Next →
        </Button>
      </Box>


         {errors.images && (
        <Typography sx={{ mt: 1, fontSize: "14px", color: "red" }}>
          {errors.images}
        </Typography>
      )}
      
    </Box>
  );
};

export default UploadStep;